import {useAppContext} from "../../context/AppContext";
import MessageSelectedCheck from "./MessageSelectedCheck";
import EmptyLine from "../outputs/EmptyLine";
import MessageSelectedComparison from "./MessageSelectedComparison";

export default function MessageTab({type, operation}) {
    const {getSelectedHistory, getOperationItemConfig} = useAppContext()

    // The old "Overview" fallback (InternalSummaryPanel / CompareSummaryPanel)
    // has been removed — the Overview is now its own operation group (OV1..OV4),
    // so the Message tab always renders the selected operation's component.
    const item = getOperationItemConfig()
    if(!item)
        return <></>

    const {Component} = item

    return (
        <div style={{backgroundColor: 'white'}}>
            <div>
                <EmptyLine />
                <div style={{marginLeft: 8}}>
                    {type === 'Check' && <MessageSelectedCheck dataSource={[getSelectedHistory()]} />}
                    {type === 'Comparison' && <MessageSelectedComparison dataSource={[getSelectedHistory()]} />}
                </div>
                <Component
                    data={operation?.data}
                    message_key={operation.key}
                />
            </div>
        </div>
    )
}
